var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFortune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 419.61 419.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 210.12,
    y1: 209.8,
    x2: 210.12,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 402.4,
    y1: 210.12,
    x2: 210.12,
    y2: 209.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 210.12,
    y1: 402.4,
    x2: 210.12,
    y2: 209.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.2,
    y1: 210.12,
    x2: 210.12,
    y2: 209.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.79,
    y1: 345.92,
    x2: 210.12,
    y2: 209.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 345.5,
    y1: 345.92,
    x2: 210.12,
    y2: 209.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 345.5,
    y1: 73.68,
    x2: 210.12,
    y2: 209.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.79,
    y1: 73.68,
    x2: 210.12,
    y2: 209.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 345.5,
    y1: 73.68,
    x2: 69.84,
    y2: 73.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.2,
    y1: 210.12,
    x2: 73.79,
    y2: 73.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 210.12,
    y1: 17.2,
    x2: 73.79,
    y2: 73.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 345.5,
    y1: 73.68,
    x2: 210.12,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 402.4,
    y1: 210.12,
    x2: 345.5,
    y2: 73.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 345.5,
    y1: 345.92,
    x2: 402.4,
    y2: 210.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 210.12,
    y1: 402.4,
    x2: 345.5,
    y2: 345.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.79,
    y1: 345.92,
    x2: 210.12,
    y2: 402.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.2,
    y1: 210.12,
    x2: 73.79,
    y2: 345.92
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.29 2.04 218.31 17.2 225.29 32.37 210.12 25.4 194.95 32.37 201.93 17.2 194.95 2.04 210.12 9.01 225.29 2.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.29 387.24 218.31 402.4 225.29 417.57 210.12 410.59 194.95 417.57 201.93 402.4 194.95 387.24 210.12 394.21 225.29 387.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "417.57 194.95 410.59 210.12 417.57 225.29 402.4 218.31 387.24 225.29 394.21 210.12 387.24 194.95 402.4 201.93 417.57 194.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.37 194.95 25.4 210.12 32.37 225.29 17.2 218.31 2.04 225.29 9.01 210.12 2.04 194.95 17.2 201.93 32.37 194.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.24 345.92 79.58 351.72 73.79 367.37 68 351.72 52.34 345.92 68 340.13 73.79 324.47 79.58 340.13 95.24 345.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "366.95 345.92 351.3 351.72 345.5 367.37 339.71 351.72 324.06 345.92 339.71 340.13 345.5 324.47 351.3 340.13 366.95 345.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.24 73.68 79.58 79.48 73.79 95.13 68 79.48 52.34 73.68 68 67.89 73.79 52.23 79.58 67.89 95.24 73.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "366.95 73.68 351.3 79.48 345.5 95.13 339.71 79.48 324.06 73.68 339.71 67.89 345.5 52.23 351.3 67.89 366.95 73.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "228.21 202.25 217.61 209.78 228.26 217.25 215.43 215.08 217.68 227.9 210.14 217.29 202.67 227.94 204.84 215.11 192.03 217.36 202.63 209.82 191.98 202.35 204.81 204.52 202.56 191.71 210.1 202.31 217.57 191.67 215.4 204.49 228.21 202.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortune);
export default __webpack_public_path__ + "static/media/Fortune.2eddbcba724d9edacae299f2432c3a0d.svg";
export { ForwardRef as ReactComponent };